import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34543016"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "mt-2 flex flex-col gap-2"
}
const _hoisted_2 = { class: "flex flex-col items-start gap-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-emphasis" }, " Learn More: ", -1))
const _hoisted_4 = {
  key: 0,
  class: "wistia-container"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("iframe", {
  src: "https://fast.wistia.net/embed/iframe/pwm8uaw7bx",
  allow: "autoplay; fullscreen",
  class: "w-full"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]

import { ref } from 'vue';
import Icon from '@/components/ui/Icon.vue';
import ChecklistsTitle from '@/components/checklists/ChecklistsTitle.vue';
import useChecklists from '@/checklists/useChecklists';
import ChecklistsSection from '@/components/checklists/ChecklistsSection.vue';
import ChecklistsExpandedSection from '@/components/checklists/ChecklistsExpandedSection.vue';
import { showIntercom } from '@/lib/intercom-helper';

interface Props {
  onSectionClick: (sectionId: string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChecklistsMainContent',
  props: {
    onSectionClick: { type: Function }
  },
  setup(__props: any) {


const { sections } = useChecklists();



const sectionIds = Object.keys(sections.value);

const isOpenVideoShown = ref(false);

const openIntercom = () => {
  showIntercom();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChecklistsTitle),
    (_unref(sectionIds).length === 1)
      ? (_openBlock(), _createBlock(ChecklistsExpandedSection, {
          key: 0,
          "can-go-back": false,
          "section-id": _unref(sectionIds)[0]
        }, null, 8, ["section-id"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sectionIds), (sectionId) => {
            return (_openBlock(), _createBlock(ChecklistsSection, {
              key: sectionId,
              "on-click": () => __props.onSectionClick(sectionId),
              "section-id": sectionId
            }, null, 8, ["on-click", "section-id"]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "text-gradient-primary inline-flex gap-1 items-center cursor-pointer text-sm font-medium p-0 border-none",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpenVideoShown.value = !isOpenVideoShown.value))
      }, [
        _createVNode(Icon, {
          type: "play",
          class: "fill-[url(#svg-bg-gradient)] h-4 w-4"
        }),
        _createTextVNode(" Watch a Quick Start Video ")
      ]),
      (isOpenVideoShown.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "text-gradient-primary inline-flex gap-1 items-center cursor-pointer text-sm font-medium",
        onClick: openIntercom
      }, [
        _createVNode(Icon, {
          type: "help-circle",
          class: "fill-[url(#svg-bg-gradient)] h-4 w-4"
        }),
        _createTextVNode(" Ask our Live Onboarding Team Your Question ")
      ])
    ])
  ], 64))
}
}

})